import { render, staticRenderFns } from "./VDropdownMenu.vue?vue&type=template&id=1cdb2ae9"
import script from "./VDropdownMenu.vue?vue&type=script&lang=js"
export * from "./VDropdownMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports